import { render, staticRenderFns } from "./emojiPicker.vue?vue&type=template&id=5aa7f173&lang=pug"
import script from "./emojiPicker.vue?vue&type=script&lang=js"
export * from "./emojiPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports